import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import ReactGA from 'react-ga';

import Footer from './partials/footer/Footer';
import Header from './partials/header/Header';
import HeaderMobile from './partials/header/HeaderMobile';
import Giftideas from '../pages/Giftideas';
import Giftlists from '../pages/Giftlists';
import Shoppinglist from '../pages/Shoppinglist';
import useGlobal from '../store';
import SidePanels from '../components/SidePanels/SidePanels';
import Giftlist from '../pages/Giftlist';
import LoadingOverlay from '../components/General/LoadingOverlay';
import ReactNotification from 'react-notifications-component'
import * as utils from '../services/utils';
import MyGiftlistPage from '../pages/MyGiftlistPage';
import GiftIdeaPage from '../pages/GiftIdeaPage';

const Layout = (props) => {

    let appLocation = useLocation();

    useEffect(() => {
        console.log('NEW PAGEVIEW', appLocation.pathname);
        ReactGA.pageview();
    }, [appLocation]);

    const [state, actions] = useGlobal(
        state => state,
        actions => actions
    );

    
    useEffect(() => {   
        ReactGA.initialize('UA-29069066-4'); 
        let token = utils.getCookie('cla_token');
        if(!token) {
            console.log('not logged in');
            window.location = "https://www.christmaslistapp.com/sign-in";
        }
        actions.userActions.getMe(token);
    }, [actions.userActions]);
    
    useEffect(() => {
        if(!state.auth) {
            return;
        }
        console.log('got auth data', state.auth);	
        ReactGA.set({ userId: state.auth.cla_uid });

        //pull in all user data
        
        actions.userActions.getUserById(state.auth.cla_uid);
        actions.userActions.getUserShoppinglist(state.auth.cla_uid);
        actions.userActions.getUserGiftlists(state.auth.cla_uid);
        actions.userActions.getUserSuggested(state.auth.cla_uid);
        actions.userActions.getUserGiftlist(state.auth.cla_uid);
        actions.userActions.getUserArchive(state.auth.cla_uid);
        actions.userActions.getUserActivityFeed(state.auth.cla_uid);
        

        ReactGA.event({
            category: 'BETA',
            action: 'APP INIT'
          });

	}, [state.auth, actions.userActions]);

    //notification triggers
    useEffect(() => {
        if(!state.response) {
            return;
        }
        console.log('NEW RESPONSE SIDE PANEL', state.response);
        if(state.response.data && state.response.data.ok === false) {
            actions.uiActions.createNotification("Bah Humbug!", "Something went wrong.", "danger");
            return;
        }
        if(state.response.type === "addgiftlist") {
            actions.uiActions.createNotification("Joy to the World!", state.response.data.FirstName + "'s gift list added.");
            actions.userActions.getUserSuggested();
            actions.uiActions.clearResponse();
        } else if (state.response.type === "additem" || state.response.type === "addarchiveditem") {
            actions.uiActions.createNotification("Ho Ho Ho!", "New gift added.");
        } else if (state.response.type === "addgiftidea") {
            actions.uiActions.createNotification("Ho Ho Ho!", "New gift added.");
        } else if (state.response.type === "updateprofile") {
            actions.uiActions.createNotification("Be Merry!", "Profile changes saved.");
        } else if (state.response.type === "deletegiftlist") {
            actions.uiActions.createNotification("Success!", "Gift list removed.");
        } else if (state.response.type === "updatebudget") {
            actions.uiActions.createNotification("Way to go!", "Budget saved.");
        } else if (state.response.type === "giftlistupdate") {
            actions.uiActions.createNotification("Way to go!", "Budget saved.");
        } else if (state.response.type === "updategiftlist") {
            actions.uiActions.createNotification("Ho Ho Ho!", "Gift list changes saved.");
        } 
        //FELIZ NAVIDAD

    }, [state.response, actions])


    const closeChat = () => {      
        if(window.$chatwoot.isOpen) {
          window.$chatwoot.toggle();
        }
    }

  return (
      <>    
      <ReactNotification />
      
    <div onClick={()=> closeChat()} className="kt-grid kt-grid--hor kt-grid--root">
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
                <HeaderMobile></HeaderMobile>    
                <Header></Header>
              
                <div className="kt-container  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-grid--stretch">
                    <div className="kt-body kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-grid--stretch" id="kt_body">
                        <div style={{minHeight:"300px"}} className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
                        { state.auth ?
                            <Switch>
                                <Route
                                    path="/my-giftlist"
                                    render={props => <MyGiftlistPage {...props} />}
                                />
                                <Route
                                    path="/gift-list/:uid"
                                    render={props => <Giftlist {...props} />}
                                />
                                <Route
                                    path="/gift-ideas"
                                    component={Giftideas}
                                />
                                <Route
                                    path="/gift-idea/:gid"
                                    component={GiftIdeaPage}
                                />
                                <Route
                                    path="/gift-lists"
                                    component={Giftlists}
                                />
                                <Route
                                    path="/shopping-list"
                                    component={Shoppinglist}
                                />
                                <Redirect from="/" to="/my-giftlist" />
                            </Switch> : <LoadingOverlay height="10rem" width="10rem" color="primary" opacity="0.1"></LoadingOverlay> }
                           
                        </div>
                    </div>
                </div>

                <Footer></Footer>

            </div>
        </div>
        
    </div>
    <SidePanels></SidePanels>
    </>
    

  );
}

export default Layout;
